export class User {
  userName: string;
  password: string;
  token: string;
  role: number;
  activeRole: number;
  displayName: string;

  //getRoles(): string[] {
  //  let roles: string[] = [];
  //  if (128 == (this.roles & 128)) roles.push("Supervisor");
  //  if (64 == (this.roles & 64)) roles.push("Management");
  //  if (32 == (this.roles & 32)) roles.push("Role6");
  //  if (16 == (this.roles & 16)) roles.push("Coach");
  //  if (8 == (this.roles & 8)) roles.push("Role4");
  //  if (4 == (this.roles & 4)) roles.push("Trainer");
  //  if (2 == (this.roles & 2)) roles.push("Trainer (extern)");
  //  if (1 == (this.roles & 1)) roles.push("Auditor");
  //  if (this.roles === 0) roles.push("No Role");
  //  return roles;
  //}

  //getTest() {
  //  return "test";
  //}
}



// WEBPACK FOOTER //
// ./src/app/_models/user.ts